export default {
  statScientistsTitle: "科学家和研究人员",
  statScientistsDescription: "致力于推动制药研发创新的专业人才",
  statScientistsImage: "https://readdy.ai/api/search-image?query=%E4%B8%93%E4%B8%9A%E5%8C%BB%E8%8D%AF%E7%A7%91%E5%AD%A6%E5%AE%B6%E5%92%8C%E7%A0%94%E7%A9%B6%E4%BA%BA%E5%91%98%E5%9C%A8%E7%8E%B0%E4%BB%A3%E5%AE%9E%E9%AA%8C%E5%AE%A4%E5%B7%A5%E4%BD%9C&width=400&height=300",
  statProductsTitle: "制药产品",
  statProductsDescription: "高质量制药产品和API的综合产品组合",
  statProductsImage: "https://readdy.ai/api/search-image?query=%E9%AB%98%E8%B4%A8%E9%87%8F%E5%8C%BB%E8%8D%AF%E4%BA%A7%E5%93%81%E7%9A%84%E7%BB%BC%E5%90%88%E4%BA%A7%E5%93%81%E7%BB%84%E5%90%88&width=400&height=300",
  statMarketsTitle: "全球市场",
  statMarketsDescription: "在多样化的国际市场中以卓越的监管能力服务医疗需求",
  statMarketsImage: "https://readdy.ai/api/search-image?query=%E5%85%A8%E7%90%83%E5%8C%BB%E8%8D%AF%E5%B8%82%E5%9C%BA%E5%92%8C%E5%9B%BD%E9%99%85%E5%8C%BB%E7%96%97%E5%88%86%E9%94%80&width=400&height=300",
};

